const FeatureFlags = {
    comparisonFeature: window._env_.REACT_APP_USE_COMPARISON_FEATURE_FLAG,
    aasListFeature: window._env_.REACT_APP_USE_AAS_LIST_FEATURE_FLAG,
};
export default FeatureFlags;
